@if (hasOverlay()) {
  <div class="preloader-overlay"></div>
}

<div
  class="preloader"
  [class.position-absolute-center]="position() === 'absolute-center'"
>
  <div class="preloader-item"></div>
  <div class="preloader-item"></div>
  <div class="preloader-item"></div>
  <div class="preloader-item"></div>
</div>
